<div class="close-container">
  <mat-icon class="close-icon" (click)="dialogRef.close()"></mat-icon>
</div>
<div class="title title--lg dialog" mat-dialog-title>Confirm</div>
<mat-dialog-content>Are you sure you want to <span><strong>{{data.displayMessage}}</strong></span> this
  application?
</mat-dialog-content>
<br>
<mat-dialog-actions>
  <div class="btn--inline dialog-btn-container">
    <button class=" btn btn--small btn--solid btn--red" (click)="confirm(data.action)">Yes</button>
    <button (click)="dialogRef.close()" class=" btn btn--small btn--solid btn--red">CLOSE</button>
  </div>  

</mat-dialog-actions>